<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          <p class="small mb-0">© {{ currentYear }} <strong>RestoreHair</strong> <br> Designed & Developed by
            <strong><a href="https://brainexworld.com/" target="_blank">Brainex World Pvt.
                Ltd.<sup>pk</sup></a></strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>